/* LOCAL ONLY; production snippet stays disabled until separate publication approval. */
(function(){
 'use strict';
 const node=document.getElementById('hm-marquise-production-config-v2');
 if(!node)return;
 let config;try{config=JSON.parse(node.textContent);}catch(_){return;}
 if(config.enabled!==true)return;
 if(typeof window.HERIMYSTInstallMarquiseProductionV2==='function')window.HERIMYSTInstallMarquiseProductionV2(window,config);
})();
